<script setup lang="ts">
import IconCancel from '@/domains/common/components/icons/IconCancel.vue';
import ButtonColorEnum from '@/domains/common/typescript/ButtonColorEnum';
import type { Component } from 'vue';

const {
    message,
    id,
    bgColor,
    textColor,
    closable = true,
    sideEffect,
} = defineProps<{
    message: string;
    id: number;
    bgColor: string;
    textColor: string;
    closable?: boolean;
    sideEffect: {
        label: string;
        effect(): void;
        icon?: Component;
    };
}>();

const emit = defineEmits<{
    'hide': [id: number];
}>();
</script>

<template>
    <div :class="['relative flex h-12 w-full items-center justify-center gap-4 rounded-full', textColor, bgColor]">
        <span class="text-lg font-bold">{{ message }}</span>
        <BaseButton
            v-if="sideEffect"
            :color="ButtonColorEnum.Secondary"
            :icon="sideEffect.icon"
            class="h-7 rounded-full border-0! text-black!"
            @click="sideEffect.effect"
        >
            {{ sideEffect.label }}
        </BaseButton>
        <BaseButton
            v-if="closable"
            class="absolute right-4"
            :icon="IconCancel"
            label=""
            :show-label="false"
            @click="emit('hide', id)"
        />
    </div>
</template>
